export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-US').format(num);
};

export const formatPercentage = (value) => {
  return `${value.toFixed(1)}%`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};

export const getStatusColor = (status) => {
  const colors = {
    pending: 'hsl(45, 90%, 55%)',
    approved: 'hsl(142, 70%, 42%)',
    rejected: 'hsl(0, 72%, 51%)',
    completed: 'hsl(220, 85%, 52%)',
    processing: 'hsl(220, 85%, 52%)',
  };
  return colors[status] || colors.pending;
};

export const getAssetTypeIcon = (type) => {
  return type === 'truck' ? 'Truck' : 'Container';
};